<nav [attr.aria-label]="ariaLabel">
  <!-- Screen reader announcements for slim mode popup state -->
  <div 
    class="sr-only" 
    role="status" 
    aria-live="polite" 
    aria-atomic="true"
    #srAnnouncement
  ></div>
  
  <ul class="sidebar-menu" role="menubar" [attr.aria-orientation]="'vertical'">
    <ng-container *ngFor="let section of sections; let i = index">
      <li *ngIf="section.hasVisibleItems()" role="none">
        <button 
          [id]="'menu-button-' + i"
          (click)="toggleSection(section, i, $event)"
          [attr.aria-expanded]="slim ? isExpanded(i) : true"
          [attr.aria-controls]="'menu-section-' + i"
          [attr.aria-haspopup]="slim ? 'menu' : null"
          role="menuitem"
          tabindex="0"
        >
          <i 
            [class]="section.logoClass" 
            aria-hidden="true"
          ></i>
          {{ section.label }}
        </button>

        <!-- Non-slim mode: inline list (always visible) -->
        <ul 
          *ngIf="!slim"
          [id]="'menu-section-' + i"
          role="menu"
          [attr.aria-labelledby]="'menu-button-' + i"
        >
          <ng-container *ngFor="let link of section.getVisibleLinks()">
            <li [class.active]="link.isActive" role="none">
              <a 
                *ngIf="!link.isExternalLink"
                [routerLink]="link.routerLink"
                [attr.title]="link.title || null"
                [attr.aria-current]="link.isActive ? 'page' : null"
                role="menuitem"
                tabindex="0"
              >
                <i *ngIf="link.displayIconClass" [class]="link.displayIconClass" aria-hidden="true"></i>
                {{ link.label }}
              </a>
              <a 
                *ngIf="link.isExternalLink"
                [href]="link.href"
                [attr.title]="link.title || null"
                target="_blank"
                rel="noopener noreferrer"
                role="menuitem"
                tabindex="0"
              >
                <i *ngIf="link.displayIconClass" [class]="link.displayIconClass" aria-hidden="true"></i>
                {{ link.label }}
              </a>
            </li>
          </ng-container>
        </ul>

        <!-- Slim mode: popup overlay -->
        <div 
          *ngIf="slim" 
          class="sidebar-nav-popup"
          [id]="'menu-section-' + i"
          [ngStyle]="getPopupStyle(i)"
          [style.display]="isExpanded(i) ? 'block' : 'none'"
          [attr.aria-hidden]="!isExpanded(i)"
          role="menu"
          [attr.aria-labelledby]="'menu-button-' + i"
        >
          <ul role="none">
            <ng-container *ngFor="let link of section.getVisibleLinks()">
              <li [class.active]="link.isActive" role="none">
                <a 
                  *ngIf="!link.isExternalLink"
                  [routerLink]="link.routerLink"
                  [attr.title]="link.title || null"
                  [attr.aria-current]="link.isActive ? 'page' : null"
                  role="menuitem"
                  [attr.tabindex]="isExpanded(i) ? '0' : '-1'"
                  (click)="closePopup()"
                >
                  <i *ngIf="link.displayIconClass" [class]="link.displayIconClass" aria-hidden="true"></i>
                  {{ link.label }}
                </a>
                <a 
                  *ngIf="link.isExternalLink"
                  [href]="link.href"
                  [attr.title]="link.title || null"
                  target="_blank"
                  rel="noopener noreferrer"
                  role="menuitem"
                  [attr.tabindex]="isExpanded(i) ? '0' : '-1'"
                  (click)="closePopup()"
                >
                  <i *ngIf="link.displayIconClass" [class]="link.displayIconClass" aria-hidden="true"></i>
                  {{ link.label }}
                </a>
              </li>
            </ng-container>
          </ul>
        </div>
      </li>
    </ng-container>
  </ul>
</nav>
